import React from 'react';
import {toast} from "../../../utils";
import successIcon from "../../../assets/icon/success.svg"
import warningIcon from "../../../assets/icon/warning.svg"
import errorIcon from "../../../assets/icon/error.svg"

const Toast = (message, type) => {
    switch (type) {
        case "error":
            return(
                toast.error(<div style={{display: "flex", alignItems: 'center'}}><img style={{marginRight: "13px", height: "22.5px", width: "22.5px"}} src={errorIcon} alt="error"/><div>{message}</div></div>)
            )
        case "success":
            return(
                toast.success(<div style={{display: "flex", alignItems: 'center'}}><img style={{marginRight: "13px", height: "22.5px", width: "22.5px"}} src={successIcon} alt="success"/><div>{message}</div></div>)
            )

        case "warning":
            return(
                toast.warning(<div style={{display: "flex", alignItems: 'center'}}><img style={{marginRight: "13px", height: "22.5px", width: "22.5px"}} src={warningIcon} alt="warning"/><div>{message}</div></div>)
            )
        default:
            break
    }
};

export default Toast;
